<template>
  <div>
    <gat-grid
      :items="tasks"
      :columns="columns"
      :title="title"
      reloadBtn
      @reload-clicked="fetchData(true)"
      :loading="isLoading"
      viewGroupName="viewTaskList"
      :height="windowHeight"
      :fixedheader="true"
      :dense="denseMode"
      :selectable="isSelectable"
      keyName="ID"
      :selectedKeys="selectedItemKeys"
      @selectionChanged="showLinkedPeople($event)"
      @row-clicked="editTask"
      hide-empty-columns>
      <template slot="btns">
        <v-menu v-if="userHasAccess && callId != 0" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small color="primary" class="mr-1" v-bind="attrs" v-on="on">
              <v-icon left small>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="newTask(1)">
              <v-list-item-icon><v-icon>mdi-bed</v-icon></v-list-item-icon>
              <v-list-item-title>Accommodation</v-list-item-title>
            </v-list-item>
            <v-list-item @click="newTask(2)">
              <v-list-item-icon><v-icon>mdi-bus</v-icon></v-list-item-icon>
              <v-list-item-title>Transport</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <wm-button-group
          class="right mr-1"
          :buttons="wmButtonGroup"
          @createEmailClick="(val) => createEmailClick(val)" />
      </template>
      <template slot="cell" slot-scope="props">
        <div v-if="props.column.field == 'OPERATION'">
          <v-tooltip bottom v-if="props.value == 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="green" v-bind="attrs" v-on="on">mdi-airplane-landing</v-icon>
            </template>
            <span>Embarking</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="red" v-bind="attrs" v-on="on">mdi-airplane-takeoff</v-icon>
            </template>
            <span>Disembarking</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 2">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="blue" v-bind="attrs" v-on="on">mdi-circle-double</v-icon>
            </template>
            <span>Other</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'STATUS'">
          <v-tooltip bottom v-if="props.value == 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="blue" v-bind="attrs" v-on="on">mdi-timer-sand-empty</v-icon>
            </template>
            <span>In progress</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="green" v-bind="attrs" v-on="on">mdi-check-circle</v-icon>
            </template>
            <span>Completed</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 2">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="red" v-bind="attrs" v-on="on">mdi-alert-circle</v-icon>
            </template>
            <span>Cancelled</span>
          </v-tooltip>
          <v-tooltip bottom v-if="props.row.LOCK_FLAG && props.row.LOCK_FLAG === 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-1" color="grey--darken-2" v-bind="attrs" v-on="on" small>mdi-lock</v-icon>
            </template>
            <span>Locked</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'hasRemark'">
          <v-tooltip bottom v-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-message-bulleted</v-icon>
            </template>
            <span>{{ props.row.REMARKS }}</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'Attachment'">
          <v-tooltip bottom v-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-paperclip</v-icon>
            </template>
            <span>Attachments</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'TransOrAccom'">
          <v-tooltip bottom v-if="props.value == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-bed-empty</v-icon>
            </template>
            <span>Accommodation</span>
          </v-tooltip>
          <v-tooltip bottom v-else-if="props.value == 2">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-bus</v-icon>
            </template>
            <span>Transport</span>
          </v-tooltip>
        </div>
        <div v-else-if="props.column.field == 'CLIENT_NAME'">
          <router-link
            v-if="props.value"
            :to="{ name: 'clientDetails', params: { clientId: props.row.CLIENT_ID } }"
            class="gridLink"
            >{{ props.value }}</router-link
          >
        </div>
      </template>
    </gat-grid>
    <email-generator :portcallId="callId" location="crewchange task" :guid="emailTemplateGuid" />
  </div>
</template>

<script>
import { apiGet, apiPut } from '@/store/api';
import GatUtils from '@/app-components/GatUtils';
import EmailGenerator from '@/app-components/EmailGenerator.vue';
import { useAppStatusStore } from '@/store/appStatusStore';
import { useApplicationStore } from '@/store/applicationStore';
import { usePortcallStore } from '@/store/portcallStore';
import { getCrewChangeTasks } from '@/services/api/api-calls/getCrewChangeTasks';
import { getCrewChangeGridFields } from '@/services/api/api-calls/getCrewChangeGridFields';
import { GlobalHelperFunctions } from '@/common/GlobalHelperFunctions';
import { useHelperStore } from '@/store/helperStore';

export default {
  name: 'CrewChangeTaskList',
  props: {
    callId: [Number, String],
    fullsize: [Boolean],
    title: [String],
  },
  components: { EmailGenerator },
  setup() {
    const appStatusStore = useAppStatusStore();
    const applicationStore = useApplicationStore();
    const portcallStore = usePortcallStore();
    const helperStore = useHelperStore();
    return {
      portcallStore,
      applicationStore,
      appStatusStore,
      helperStore,
    };
  },
  data() {
    return {
      isLoading: false,
      selectedItemKeys: [],
      taskByPeople: [],
      taskFilter: [],
      operationFilter: [],
      statusFilter: [],
      denseMode: false,
      upcomingTasks: {},
      emailTemplates: [],
      emailTemplateGuid: undefined,
      gridFieldConfig: [],
    };
  },

  activated() {
    this.fetchData();
    this.fetchGridFieldConfig();
  },

  mounted() {
    window.messageBus.$on('tasksFilteredByPeople', (taskArray) => {
      this.selectedItemKeys = [];
      this.taskByPeople = GatUtils.makeCopyViaJson(taskArray);
    });

    window.messageBus.$on('crewChangeFilterOperation', (operationChoice) => {
      this.operationFilter = operationChoice;
    });

    window.messageBus.$on('crewChangeFilterStatus', (statusChoice) => {
      this.statusFilter = statusChoice;
    });

    window.messageBus.$on('crewChangeFilterTask', (taskChoice) => {
      this.taskFilter = taskChoice;
    });

    window.messageBus.$on('crewChangeFilterDense', (denseChoise) => {
      this.denseMode = denseChoise;
    });
  },

  created() {
    // this.fetchData();
  },

  watch: {
    // callId: {
    //   handler() {
    //     this.fetchData();
    //   },
    //   immediate: true,
    // },
    'applicationStore.user.externalClientId': {
      handler() {
        this.fetchData();
      },
    },
  },

  computed: {
    isTransportPage() {
      return this.$route.path === '/transports';
    },
    isAccommodationPage() {
      return this.$route.path === '/accommodations';
    },
    columns() {
      // Define all possible columns mapped to their ccm_field FIELDNAME
      const allColumns = {
        cTasks_Operation: { header: 'Op.', field: 'OPERATION' },
        cTasks_TranspOrAccom: { header: 'Ty.', field: 'TransOrAccom' },
        cTasks_status: { header: 'Status', field: 'STATUS' },
        cTasks_TypeBeskr: { header: this.getHeaderForDescription, field: 'TypeBeskr', nowrap: true },
        cTasks_AntallConnections: { header: '#', field: 'AntConnections' },
        cTasks_status_type: { header: 'Status', field: 'NAME', hideOnPhone: true, nowrap: true },
        cTasks_Attachments: { header: 'Doc.', field: 'Attachment' },
        cTasks_HasRemarks: { header: 'Rem', field: 'hasRemark' },
        cTasks_ClientName: { header: this.getHeaderForClient, field: 'CLIENT_NAME', nowrap: true },
        cTasks_PickupPlace: { header: this.getHeaderForPlace, field: 'PICKUP_PLACE', nowrap: true },
        cTasks_DatetimeStart: { header: this.getHeaderForStart, field: 'DATETIME_START', dataType: 'datetime' },
        cTasks_DestinationPlace: { header: this.getHeaderForDestination, field: 'DESTINATION_PLACE' },
        cTasks_DatetimeEnd: { header: this.getHeaderForEnd, field: 'DATETIME_END', dataType: 'datetime' },
        cTasks_TotalPrice: {
          header: 'Exp. total',
          field: 'totPrice',
          dataType: 'number',
          footerFunction: { fn: 'sum' },
        },
        cTasks_Debtor: { header: 'Debtor', field: 'Debtor', nowrap: true },
        cTasks_PO: { header: 'PO No', field: 'PO_NO', nowrap: true },
        cTasks_Last_updated: { header: 'Last updated', field: 'LAST_UPDATED', dataType: 'date' },
        cTasks_Last_exported: { header: 'Last exported', field: 'LAST_EXPORTED', dataType: 'date' },
      };

      // Permission-based column restrictions
      const permissionFilter = (fieldName) => {
        // Internal-only columns
        const internalOnly = ['cTasks_Attachments', 'cTasks_HasRemarks', 'cTasks_Last_updated', 'cTasks_Last_exported'];
        if (internalOnly.includes(fieldName) && !this.applicationStore.user.internal) {
          return false;
        }
        // Expense-related columns
        const expenseColumns = ['cTasks_TotalPrice', 'cTasks_Debtor'];
        if (expenseColumns.includes(fieldName) && !this.applicationStore.userRight('CRCH.SHOW_EXPENSES')) {
          return false;
        }
        // Accommodation page: hide pickup/destination
        if (
          this.isAccommodationPage &&
          (fieldName === 'cTasks_PickupPlace' || fieldName === 'cTasks_DestinationPlace')
        ) {
          return false;
        }
        // Transport/Accommodation standalone pages don't need destination hidden
        if (!this.isAccommodationPage && fieldName === 'cTasks_DestinationPlace') {
          return true;
        }
        return true;
      };

      // Build dynamic field columns from task data
      const getDynaFieldColumns = () => {
        const dynaCols = [];
        if (!this.applicationStore.user.internal) return dynaCols;
        const taskDynafields = [];
        let tasks;
        if (this.isTransportPage || this.isAccommodationPage) {
          tasks = this.upcomingTasks?.tasks;
        } else {
          tasks = this.portcallStore.crewChange.tasks?.tasks;
        }
        if (tasks) {
          tasks.forEach((task) => {
            Object.keys(task).forEach((key) => {
              if (key.startsWith('dyn_') && !taskDynafields.includes(key)) taskDynafields.push(key);
            });
          });
          for (let index = 0; index < this.helperStore.dynafields.length; index++) {
            const dynafield = this.helperStore.dynafields[index];
            if (dynafield.COMPONENT_NAME === 'pDynaFields.CrewChangeDynaTask') {
              if (taskDynafields.includes(`dyn_${dynafield.ID}`)) {
                const col = {
                  header: dynafield.CAPTION,
                  field: `dyn_${dynafield.ID}`,
                  dataType: this.getDataTypeByFieldTypeId(dynafield.FIELD_TYPE),
                };
                if (col.dataType === 'number') {
                  col.numberFormat = '0,0';
                }
                dynaCols.push(col);
              }
            }
          }
        }
        return dynaCols;
      };

      // Build expense template columns
      const getExpenseColumns = () => {
        const expCols = [];
        if (!this.applicationStore.userRight('CRCH.SHOW_EXPENSES')) return expCols;
        let templates;
        if ((this.isTransportPage || this.isAccommodationPage) && this.upcomingTasks?.usedExpenseTemplates) {
          templates = this.upcomingTasks.usedExpenseTemplates;
        } else if (this.portcallStore.crewChange.tasks?.usedExpenseTemplates) {
          templates = this.portcallStore.crewChange.tasks.usedExpenseTemplates;
        }
        if (templates) {
          for (let i = 0; i < templates.length; i++) {
            expCols.push({
              header: `${templates[i].ELT_NAME} Qty`,
              field: `exp_quantity${templates[i].ELT_ID}`,
              footerFunction: { fn: 'sum' },
              dataType: 'number',
            });
            expCols.push({
              header: 'Price',
              field: `exp_price${templates[i].ELT_ID}`,
              dataType: 'number',
            });
            expCols.push({
              header: 'Amount',
              field: `exp_amount${templates[i].ELT_ID}`,
              footerFunction: { fn: 'sum' },
              dataType: 'number',
            });
          }
        }
        return expCols;
      };

      // If we have grid field config, use it for ordering and visibility
      if (this.gridFieldConfig && this.gridFieldConfig.length > 0) {
        const result = [];
        const visibleConfiguredColumns = [];
        let dynaSortOrder = Infinity;
        let expenseSortOrder = Infinity;
        const dynaColumns = getDynaFieldColumns();
        const expenseColumns = getExpenseColumns();

        this.gridFieldConfig.forEach((fieldConfig) => {
          const fieldName = fieldConfig.FIELDNAME.trim();
          const normalizedFieldName = fieldName.toUpperCase();

          if (normalizedFieldName === '[DYNAMIC FIELDS]') {
            dynaSortOrder = fieldConfig.SORT_ORDER;
            return;
          }
          if (normalizedFieldName === '[EXPENSES]') {
            expenseSortOrder = fieldConfig.SORT_ORDER;
            return;
          }

          const colDef = allColumns[fieldName];
          if (colDef && fieldConfig.VISIBLE === 1 && permissionFilter(fieldName)) {
            result.push(colDef);
            visibleConfiguredColumns.push({
              field: colDef.field,
              sortOrder: fieldConfig.SORT_ORDER,
            });
          }
        });

        // Helper to find insertion index for placeholder columns
        const findInsertIndex = (placeholderSortOrder) => {
          for (let index = 0; index < visibleConfiguredColumns.length; index++) {
            const nextVisibleColumn = visibleConfiguredColumns[index];
            if (nextVisibleColumn.sortOrder > placeholderSortOrder) {
              const idx = result.findIndex((col) => col.field === nextVisibleColumn.field);
              if (idx !== -1) {
                return idx;
              }
            }
          }
          return result.length;
        };

        const placeholderColumns = [
          { columns: dynaColumns, sortOrder: dynaSortOrder, typeOrder: 0 },
          { columns: expenseColumns, sortOrder: expenseSortOrder, typeOrder: 1 },
        ]
          .filter((entry) => entry.columns.length > 0)
          .sort((left, right) => {
            if (left.sortOrder === right.sortOrder) {
              return left.typeOrder - right.typeOrder;
            }
            return left.sortOrder - right.sortOrder;
          });

        placeholderColumns.forEach((entry) => {
          result.splice(findInsertIndex(entry.sortOrder), 0, ...entry.columns);
        });

        // Add portcall/vessel columns for standalone pages
        if (this.isAccommodationPage || this.isTransportPage) {
          result.push({ header: 'Portcall', field: 'PORTCALL_ID' });
          result.push({ header: 'Vessel', field: 'Vessel' });
        }

        return result;
      }

      // Fallback: original hardcoded column order (when no config available)
      const result = [];
      result.push(allColumns.cTasks_Operation);
      result.push(allColumns.cTasks_TranspOrAccom);
      result.push(allColumns.cTasks_status);
      result.push(allColumns.cTasks_TypeBeskr);
      result.push(allColumns.cTasks_AntallConnections);
      result.push(allColumns.cTasks_status_type);

      if (this.applicationStore.user.internal) {
        result.push(allColumns.cTasks_Attachments);
        result.push(allColumns.cTasks_HasRemarks);
      }

      result.push(allColumns.cTasks_ClientName);

      if (!this.isAccommodationPage) {
        result.push(allColumns.cTasks_PickupPlace);
      }

      result.push(allColumns.cTasks_DatetimeStart);

      if (!this.isAccommodationPage) {
        result.push(allColumns.cTasks_DestinationPlace);
      }

      result.push(allColumns.cTasks_DatetimeEnd);

      if (this.isAccommodationPage || this.isTransportPage) {
        result.push({ header: 'Portcall', field: 'PORTCALL_ID' });
        result.push({ header: 'Vessel', field: 'Vessel' });
      }

      // Dynamic field columns
      const dynaCols = getDynaFieldColumns();
      result.push(...dynaCols);

      // Expense columns
      if (this.applicationStore.userRight('CRCH.SHOW_EXPENSES')) {
        const expCols = getExpenseColumns();
        result.push(...expCols);
        result.push(allColumns.cTasks_TotalPrice);
        result.push(allColumns.cTasks_Debtor);
      }

      if (this.applicationStore.user.internal) {
        result.push(allColumns.cTasks_Last_exported);
        result.push(allColumns.cTasks_Last_updated);
      }
      result.push(allColumns.cTasks_PO);
      return result;
    },

    tasks() {
      let tasks = [];
      if (this.isTransportPage || this.isAccommodationPage) {
        if (this.upcomingTasks.tasks && this.upcomingTasks.tasks.length > 0) {
          tasks = GatUtils.makeCopyViaJson(this.upcomingTasks.tasks);
        }
      } else {
        tasks = this.portcallStore.crewChange.tasks.tasks;
      }
      let newTasks = null;

      if (tasks) {
        newTasks = GatUtils.makeCopyViaJson(tasks);
        newTasks = this.filterItems(newTasks, this.operationFilter, 'OPERATION');
        newTasks = this.filterItems(newTasks, this.statusFilter, 'STATUS');

        if (this.taskFilter[0] && !this.taskFilter[1]) {
          newTasks = newTasks.filter((task) => task.TransOrAccom !== 2);
        } else if (!this.taskFilter[0] && this.taskFilter[1]) {
          newTasks = newTasks.filter((task) => task.TransOrAccom !== 1);
        }

        if (this.taskByPeople.length > 0) {
          newTasks = newTasks.filter((task) => this.taskByPeople.includes(task.ID));
        }

        if (this.isTransportPage) {
          newTasks = newTasks.filter((task) => task.TransOrAccom != 1);
        } else if (this.isAccommodationPage) {
          newTasks = newTasks.filter((task) => task.TransOrAccom != 2);
        }
      }
      return newTasks || tasks;
    },
    windowHeight() {
      let height = 0;
      const defaultHeight = 30;
      const minHeight = 18;

      if (this.fullsize) {
        return 'calc(100vh - 170px)';
      }
      if (this.tasks && this.tasks.length == 1) {
        height = minHeight;
      } else if (this.tasks && this.tasks.length < 4) {
        height = this.tasks.length * 3 + minHeight;
      } else {
        height = defaultHeight;
      }
      window.messageBus.$emit('crewChangeTaskListHeight', height);

      return `${height}vh`;
    },
    agencyId() {
      return this.portcallStore.callDetails.SETUP_ID;
    },
    wmButtonGroup() {
      const result = [];
      if ((!this.applicationStore.user.internal && this.userCanGenerateDoc) || this.applicationStore.user.internal) {
        result.push({
          btnType: 'CREATE_DOC',
          docType: 24,
          agencyId: this.agencyId,
          location: 'portcall',
          foreignKey: this.callId,
          applicationStatus: this.applicationStatus,
          disabled: !this.userCanGenerateDoc, // this.selectedItemKeys.length === 0 ||
        });
        if (
          this.applicationStore.globalSettings.SGL_WM_EMAIL_PROVIDER !== 0 &&
          this.applicationStore.userRight('EM.EDIT')
        ) {
          result.push({
            btnType: 'CUSTOM',
            caption: 'Create email',
            icon: 'mdi-email',
            menuItems: this.emailTemplateItems,
            disabled: this.emailTemplateItems.length === 0,
          });
        }
      }
      return result;
    },
    userCanGenerateDoc() {
      const isInternal = this.applicationStore.user.internal;
      if (isInternal) {
        return true;
      }
      const externalRights = this.applicationStore.userRight('CRCH.GENERATE_DOCUMENT');
      return externalRights;
    },
    isSelectable() {
      if (this.taskByPeople.length > 0) {
        return false;
      }
      return true;
    },
    applicationStatus() {
      return this.appStatusStore.getAppStatus;
      /* let result = {};
              result.PortCall = {};
              result.PortCall.Id = this.callId;
              result.PortCall.CcmTaskIds = this.selectedItemKeys
              return result; */
    },

    getHeaderForDescription() {
      if (this.isTransportPage) {
        return 'Transportation type';
      }
      if (this.isAccommodationPage) {
        return 'Room type';
      }
      return 'Description';
    },
    getHeaderForClient() {
      if (this.isTransportPage) {
        return 'Transport company';
      }
      if (this.isAccommodationPage) {
        return 'Hotel';
      }
      return 'Client';
    },
    getHeaderForStart() {
      if (this.isTransportPage) {
        return 'Pickup';
      }
      if (this.isAccommodationPage) {
        return 'Checkin';
      }
      return 'Start';
    },
    getHeaderForEnd() {
      if (this.isTransportPage) {
        return 'Drop-off';
      }
      if (this.isAccommodationPage) {
        return 'Checkout';
      }
      return 'End';
    },
    getHeaderForPlace() {
      if (this.isTransportPage) {
        return 'Pickup/start place';
      }
      return 'Place';
    },
    getHeaderForDestination() {
      if (this.isTransportPage) {
        return 'Destination place';
      }
      return 'Destination';
    },
    clientId() {
      return this.applicationStore.user.externalClientId;
    },
    userHasAccess() {
      return this.applicationStore.userRight('CRCH.ACCESS');
    },
    emailTemplateItems() {
      const templates = [...this.emailTemplates];
      let result = [];
      const ignoreGroupMinCount = this.applicationStore.hasFeatureCode('IGNORE_DOCUMENT_GROUPING_MIN_COUNT');

      if (Array.isArray(templates) && templates.length > 0) {
        if (ignoreGroupMinCount ? true : templates.length > 10) {
          result = this.helperStore.emailTemplatesGroupedByLabels(templates, false);
        } else {
          result = templates.map((item) => ({
            caption: item.TITLE,
            eventName: 'createEmailClick',
            icon: 'mdi-file-outline',
            ID: item.ID,
          }));
        }
      }
      return result;
    },
  },

  methods: {
    fetchGridFieldConfig() {
      getCrewChangeGridFields(1).then((result) => {
        if (result && result.length > 0) {
          this.gridFieldConfig = result;
        }
      });
    },
    getDataTypeByFieldTypeId(fieldType) {
      switch (fieldType) {
        case 2:
          return 'number';
        case 3:
          return 'date';
        case 12:
          return 'datetime';
        default:
          return undefined;
      }
    },
    newTask(ccType) {
      this.$router.push({ name: 'newCrewChangeTask', params: { callId: this.callId }, query: { ccType } });
    },
    editTask(task) {
      if (task && task.ID && this.callId != 0) {
        this.$router.push({ name: 'crewChangeTask', params: { callId: this.callId, taskId: task.ID } });
      }
    },
    createEmailClick(item) {
      if (this.callId) {
        const guid = GlobalHelperFunctions.GUID();
        const templateId = item.ID;
        const location = 'portcall';
        const foreignKey = this.callId;
        const appStatus = JSON.stringify(this.applicationStatus);
        const param = { guid, templateId, location, foreignKey, appStatus, isEmail: 1 };
        apiPut('document/generate/', param).then((result) => {
          if (result.resultCategory === 0 && result.resultType === 0) {
            this.emailTemplateGuid = guid;
          }
        });
      }
    },
    retrieveTasks(callId) {
      const clientId = this.getClientIdOrDefaults();
      this.isLoading = true;
      getCrewChangeTasks({ callId, clientId })
        .then(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    filterItems(tasks, filterArray, property) {
      const numOfOperationsToggled = filterArray.filter((op) => op === true).length;
      if (numOfOperationsToggled > 0 && numOfOperationsToggled != filterArray.length) {
        const newFilter = filterArray.reduce((result, element, index) => {
          if (element) {
            result.push(index);
          }
          return result;
        }, []);

        // eslint-disable-next-line no-param-reassign
        tasks = tasks.filter((task) => {
          if (newFilter.includes(task[property])) {
            return true;
          }
          return false;
        });
      }
      return tasks;
    },
    showLinkedPeople(taskId) {
      this.selectedItemKeys = taskId;
      this.appStatusStore.setAppStatusCcmTaskIds(taskId);
      this.isLoading = true;
      let peopleArray = [];
      if (taskId.length == 0) {
        window.messageBus.$emit('peopleFilteredByTask', peopleArray);
        this.isLoading = false;
      } else {
        const selectedTaskItems = this.getTaskItemBySelectedKeys();
        peopleArray = this.getPeopleFromTasks(selectedTaskItems);

        if (peopleArray.length > 0) {
          window.messageBus.$emit('peopleFilteredByTask', peopleArray);
        } else {
          // Task selected but no assigned people > Clear people table
          window.messageBus.$emit('peopleFilteredByTask', ['x']);
        }
        this.isLoading = false;
      }
    },
    getClientIdOrDefaults() {
      if (this.applicationStore.user.internal || this.applicationStore.userRight('CRCH.ACCESS')) {
        return 0;
      }
      return this.applicationStore.user.externalClientId ? this.applicationStore.user.externalClientId : null;
    },
    fetchData(forceReload = false) {
      if (this.callId != 0) {
        if (
          forceReload ||
          !this.portcallStore.crewChange.tasks.tasks ||
          this.portcallStore.crewChange.tasks.tasks.length === 0
        ) {
          this.retrieveTasks(this.callId);
        }
        apiGet(`mail/templates/crewchange task/${this.agencyId}/${true}`).then((result) => {
          if (result) {
            this.emailTemplates = result;
          }
        });
      } else {
        this.retrieveUpcomingTasks();
      }
    },
    getPeopleFromTasks(taskArray) {
      const people = [];
      for (let i = 0; i < taskArray.length; i++) {
        // eslint-disable-next-line no-restricted-syntax
        for (const prop in taskArray[i][0]) {
          if (prop.indexOf('Person_') === 0) {
            people.push(taskArray[i][0][prop]);
          }
        }
      }
      const uniquePeople = [...new Set(people)];
      return uniquePeople;
    },
    getTaskItemBySelectedKeys() {
      const tasks = [];
      for (let i = 0; i < this.selectedItemKeys.length; i++) {
        tasks.push(
          // eslint-disable-next-line @typescript-eslint/no-loop-func
          this.tasks.filter((obj) => obj.ID === this.selectedItemKeys[i])
        );
      }
      return tasks;
    },
    retrieveUpcomingTasks() {
      if (this.clientId != undefined) {
        this.isLoading = true;
        apiGet(`crewchange/upcomingTasks/${this.clientId}`)
          .then((result) => {
            this.upcomingTasks = GatUtils.makeCopyViaJson(result);
            this.isLoading = false;
          })
          .finally(() => {
            if (this.isAccommodationPage) {
              const firstAccom = this.upcomingTasks.tasks.find((task) => task.TransOrAccom == 1);
              if (firstAccom) {
                this.showLinkedPeople([firstAccom.ID]); // Select first task on Accommodation page
              }
            } else {
              const firstTransp = this.upcomingTasks.tasks.find((task) => task.TransOrAccom == 2);
              if (firstTransp) {
                this.showLinkedPeople([firstTransp.ID]); // Select first task on Transport page
              }
            }
          });
      }
    },
  },
};
</script>

<style scoped></style>
